import React, { FC, useState, useEffect } from "react";
import { Box, VStack, HStack, Text, Divider, Pressable } from "native-base";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import * as AV from "../../../AVCore/AVCore";
import { Loc } from "../../../App/Loc";

interface Props {
  entity: AV.IAVEntity;
}

export const AVFeeCollectAbout: FC<Props> = ({ entity }) => {
  const dimensions = useWindowDimension();
  const isMobile = dimensions?.width < 600;

  const [description, setDescription] = useState("");
  const [showMore, setShowMore] = useState(false);

  const MAX_WORDS = 40;

  useEffect(() => {
    if (entity?.profile?.text) {
      setDescription(entity.profile.text);
    }
  }, [entity]);

  const words = description?.split(" ") || [];
  const isLongText = words.length > MAX_WORDS;
  const truncatedText = words.slice(0, MAX_WORDS).join(" ");

  return (
    <Box
      minHeight="340px"
      bg="AVColor.white"
      borderRadius={5}
      shadow={1}
      flex={1}
      mb={3}
    >
      {/* Header */}
      <HStack justifyContent="space-between" alignItems="center" px={4} py={3}>
        <Text fontSize="22px" fontWeight="500" color="AVColor.primary">
          {Loc.currentLang.feeCollect.about}
        </Text>
      </HStack>

      <Divider my={2} />

      {/* Content */}
      <VStack p={6} space={2}>
        <Text fontSize="14px" color="coolGray.700">
          {showMore || !isLongText ? description : `${truncatedText}...`}
        </Text>

        {isLongText && (
          <Pressable onPress={() => setShowMore(!showMore)}>
            <Text fontSize="14px" color="#32AE78" fontWeight="500">
              {showMore ? "Show less" : "Show more"}
            </Text>
          </Pressable>
        )}
      </VStack>
    </Box>
  );
};

export default AVFeeCollectAbout;
